import request from "./request";
import { ENV_CONFIG } from '@/config';

// 相对路径（API 网关），暂保留；实际请求由下方 directApi 覆盖为直连后端
let api = {
  getChannelInfo: "/picText/live/Room/getInfoFronts", // 获取直播间信息
  getUserInfo: "/Program/Index/getUserInfo", // 获取用户信息
  sendChat: "/picText/live/Comment/send", // 发送聊天
  userStar: "/picText/live/Content/userStar", // 点赞
  getCommentList: "/picText/live/Comment/getCommentLists", // 获取评论内容
  getReportListFront: "/picText/live/Content/getReportListFront", // 获取列表
  getReportInfo: "/picText/live/Content/getReportInfo", // 获取报道内容
  getWxJsapiPackage: "/Program/Share/getWxJsapiPackage", // 获取微信sdk
  withdrawalsRemind: "/Program/Person/withdrawalsRemind", // 获取是否提示提现信息
  PostInfo: "/Program/Live/PostInfo", // 数据统计相关
  getGlobalSetting: '/Program/Person/getUserGlobalSetting', // 获取全局设置
  getUserBaseConfig: '/Program/Person/getUserBaseConfig', // 获取B端用户基础信息
  setReportLike: '/picText/live/Content/setReportLike', // 报道点赞
  sendComment: '/picText/live/Comment/send', // 发送评论
};

// 全部接口统一直连后端域名（所有环境）
const directApi = {
  getChannelInfo: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Room/getInfoFronts`, // 获取直播间信息
  getUserInfo: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Index/getUserInfo`, // 获取用户信息
  sendChat: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Comment/send`, // 发送聊天
  userStar: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Content/userStar`, // 点赞
  getCommentList: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Comment/getCommentLists`, // 获取评论内容
  getReportListFront: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Content/getReportListFront`, // 获取列表
  getReportInfo: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Content/getReportInfo`, // 获取报道内容
  getWxJsapiPackage: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Share/getWxJsapiPackage`, // 获取微信sdk
  withdrawalsRemind: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Person/withdrawalsRemind`, // 获取是否提示提现信息
  PostInfo: `https://${ENV_CONFIG.GO_API_DOMAIN}/v1/live/postinfo`, // 数据统计相关
  getGlobalSetting: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Person/getUserGlobalSetting`, // 获取全局配置
  getUserBaseConfig: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Person/getUserBaseConfig`, // 获取B端用户基础信息
  setReportLike: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Content/setReportLike`, // 报道点赞
  sendComment: `https://${ENV_CONFIG.PIXTEXT_API_DOMAIN}/v1/picText/live/Comment/send`, // 发送评论
};

api = { ...api, ...directApi };

export const getChannelInfo = (data) => {
  return request.get(api["getChannelInfo"], data);
};
export const getUserInfo = (data) => {
  return request.get(api["getUserInfo"], data);
};
export const sendChat = (data) => {
  return request.post(api["sendChat"], data);
};
export const userStar = (data) => {
  return request.post(api["userStar"], data);
};
export const getCommentList = (data) => {
  return request.get(api["getCommentList"], data);
};
export const getReportListFront = (data) => {
  return request.get(api["getReportListFront"], data);
};
export const getReportInfo = (data) => {
  return request.get(api["getReportInfo"], data);
};
export const getWxJsapiPackage = (data) => {
  return request.post(api["getWxJsapiPackage"], data);
};
export const PostInfo = (data) => {
  return request.post(api["PostInfo"], data);
};
export const withdrawalsRemind = (data) => {
  return request.get(api["withdrawalsRemind"], data);
};
export const getGlobalSetting = (data) => {
  return request.get(api["getGlobalSetting"], data);
};
export const getUserBaseConfig = (data) => {
  return request.get(api['getUserBaseConfig'], data)
}
export const setReportLike = (data) => {
  return request.post(api['setReportLike'], data);
};
export const sendComment = (data) => {
  return request.post(api['sendComment'], data);
};

export default {
  getChannelInfo,
  getUserInfo,
  sendChat,
  userStar,
  getCommentList,
  getReportListFront,
  getReportInfo,
  getWxJsapiPackage,
  PostInfo,
  withdrawalsRemind,
  getGlobalSetting,
  getUserBaseConfig,
  setReportLike,
  sendComment
};
